import { StyleSheet } from 'react-native';
import { themes } from '../../theme/theme';
export const styles = StyleSheet.create({
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    borderWidth: 1,
    borderRadius: 8,
    paddingHorizontal: 10,
  },
  input: {
    flex: 1,
    fontSize: 16,
    paddingVertical: 8,
  },
  iconContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 10,
    width: 20,
    height: 20,
  },
  disabledInputContainer: {
    backgroundColor: themes.light.gray_blue[6],
  },
  label: {
    fontSize: 14,
    lineHeight: 32,
    fontWeight: 'bold',
    paddingHorizontal: 1,
  },
  labelContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 4,
  },
  requiredIndicator: {
    fontSize: 16,
    fontWeight: 'bold',
    marginLeft: 4,
    color: themes.light.red[3],
  },
});
